import React from 'react';
import './index.scss';

export default function ProgressBar({ percent = 0, label = '', color = '#00ff99', height = 10, className = '' }) {
  const barStyle = {
    width: `${Math.max(0, Math.min(percent, 100))}%`,
    background: `linear-gradient(90deg, ${color}, #00ff00)`,
    height: height,
  };
  return (
    <div className={`c-progress-bar ${className}`} style={{ height }}>
      <div className="c-progress-bar-track" style={{ height }}>
        <div className="c-progress-bar-fill" style={barStyle}></div>
      </div>
      {label && <span className="c-progress-bar-label">{label}</span>}
    </div>
  );
} 